import { forwardRef } from 'react';
import NotificationCardInternal from './notification-card-internal';
import CloseButton from './close-button';
var NotificationCard = forwardRef(NotificationCardInternal);
var NotificationCardNamespace = Object.assign(NotificationCard, {
    CloseButton: CloseButton,
});
export default NotificationCardNamespace;
